export enum SupportedFeatures {
  PAYSLIPS = "Payslips",
  IRP5s = "IRP5s",
  ROSTERS = "Rosters",
  TIMESHEETS = "Timesheets",
}

export enum SupportedDocumentQueries {
  PAYSLIP_QUERY = "Payslip Query",
  ROSTER_QUERY = "Roster Query",
  TIMESHEET_QUERY = "Timesheet Query",
}

export enum SupportedLeaveQueries {
  ANNUAL_LEAVE_QUERY = "Annual leave Query",
  SICK_LEAVE_QUERY = "Sick leave Query",
  FAMILY_LEAVE_QUERY = "Family responsibility leave Query",
  MATERNITY_LEAVE_QUERY = "Maternity leave Query",
  PARENTAL_LEAVE_QUERY = "Parental leave Query",
  OTHER_LEAVE_QUERY = "Other leave Query",
  UNPAID_LEAVE_QUERY = "Unpaid leave Query",
  INJURY_LEAVE_QUERY = "Injury-on-duty leave Query",
}

export interface FeatureConfiguration {
  document_length: number;
  matching_criteria: string;
}

export default interface FeatureConfigurationModel {
  id?: number;
  employer_feature?: number;
  configuration: FeatureConfiguration;
}

export enum SupportedDocumentAttributes {
  BATCH_NAME,
  ISSUE_DATE,
  START_AND_END_PERIOD,
  DISTRIBUTION_DATES,
}
